'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import Logo from '@shared/utils/icons/Logo';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ArrowUpDown, TrendingDown, TrendingUp } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { client } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import Button from '../common/Button';
import Error from '../common/Error';
type SortOrder = 'highest' | 'lowest';
type Props = {
  factiiiId: number;
};
export const RelatedFactiiisSidebar = t0 => {
  const $ = _c(43);
  const {
    factiiiId
  } = t0;
  const [sortOrder, setSortOrder] = useState("highest");
  let t1;
  if ($[0] !== factiiiId || $[1] !== sortOrder) {
    t1 = ["RelatedFactiiis", sortOrder, factiiiId];
    $[0] = factiiiId;
    $[1] = sortOrder;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const queryKey = t1;
  let t2;
  if ($[3] !== factiiiId || $[4] !== sortOrder) {
    t2 = async t3 => {
      const {
        pageParam
      } = t3;
      return await unwrapFromResult(client.factiiis.getRelated.query({
        factiiiId,
        cursor: pageParam,
        sortOrder
      }));
    };
    $[3] = factiiiId;
    $[4] = sortOrder;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = typeof factiiiId === "number";
  let t4;
  if ($[6] !== queryKey || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      queryKey,
      queryFn: t2,
      select: _temp2,
      initialPageParam: undefined as number | undefined,
      getNextPageParam: _temp3,
      enabled: t3
    };
    $[6] = queryKey;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: data_0,
    error,
    isFetching,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery(t4);
  let t5;
  if ($[10] !== sortOrder) {
    t5 = () => {
      setSortOrder(sortOrder === "highest" ? "lowest" : "highest");
    };
    $[10] = sortOrder;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const toggleSort = t5;
  let t6;
  if ($[12] !== sortOrder) {
    t6 = sortOrder === "highest" ? <TrendingDown className="size-3" /> : <TrendingUp className="size-3" />;
    $[12] = sortOrder;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowUpDown className="size-3" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = <div className="flex items-center space-x-1">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8 || $[18] !== toggleSort) {
    t9 = <div className="mb-4 flex justify-end"><Button titleElement={t8} variant="SECONDARY" classNames="text-xs px-2 py-1" onClick={toggleSort} /></div>;
    $[17] = t8;
    $[18] = toggleSort;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== data_0) {
    t10 = data_0?.map(_temp4);
    $[20] = data_0;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <div className="space-y-2">{t10}</div>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== data_0?.length || $[25] !== error || $[26] !== isFetching) {
    t12 = !isFetching && !error && data_0?.length === 0 && <div className="flex flex-col items-center justify-center py-8 text-center"><div className="mb-3 opacity-50"><Logo height={48} rounded={true} /></div><h4 className="mb-1 text-sm font-semibold text-textPrimary">No Related Factiiis</h4><p className="text-xs text-textSecondary/70">This factiii doesn't appear together with others on posts yet.</p></div>;
    $[24] = data_0?.length;
    $[25] = error;
    $[26] = isFetching;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== fetchNextPage || $[29] !== hasNextPage || $[30] !== isFetching) {
    t13 = hasNextPage && <InView onChange={isVisible => isVisible && !isFetching ? fetchNextPage() : undefined} className="mt-4 flex justify-center"><div className="flex items-center justify-center py-2"><div className="size-4 animate-spin rounded-full border-2 border-primary border-t-transparent" /></div></InView>;
    $[28] = fetchNextPage;
    $[29] = hasNextPage;
    $[30] = isFetching;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== error || $[33] !== isFetching) {
    t14 = Boolean(error) && <Error error={error} loading={isFetching} message="Failed to load related factiiis. Please try again." />;
    $[32] = error;
    $[33] = isFetching;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t13 || $[38] !== t14) {
    t15 = <div className="flex-1 overflow-y-auto">{t11}{t12}{t13}{t14}</div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15 || $[41] !== t9) {
    t16 = <div className="flex h-full flex-col">{t9}{t15}</div>;
    $[40] = t15;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
};
function _temp(page) {
  return page.factiiisCount || [];
}
function _temp2(data) {
  return data?.pages.flatMap(_temp);
}
function _temp3(lastPage) {
  const factiiisCount = lastPage.factiiisCount ?? [];
  if (factiiisCount.length < 10) {
    return;
  }
  return factiiisCount[factiiisCount.length - 1]?.id;
}
function _temp4(factiii, index) {
  const count = factiii.count;
  return <Link key={factiii.id} href={`/f/${factiii.slug}`} className="group block rounded-lg border border-ds-border-standard bg-background-secondary p-3 transition-colors hover:bg-background-light"><div className="flex items-center justify-between"><div className="flex items-center space-x-2"><span className="w-5 text-xs text-textSecondary">{index + 1}</span><Avatar factiiiAvatarKey={factiii.avatarKey ?? null} factiiiId={factiii.id} size={28} /><div className="min-w-0 flex-1"><h4 className="truncate text-sm font-emphasis text-textPrimary group-hover:text-primary">{factiii.name}</h4><p className="truncate text-xs text-textSecondary/60">{factiii.description || `factiiis/${factiii.id}`}</p></div></div><div className="text-right"><div className="text-sm font-semibold text-textPrimary">{count}</div><div className="text-xs text-textSecondary/60">co-occurrences</div></div></div></Link>;
}